import {
  Button,
  FormControl,
  Paper,
  Typography,
  Modal,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Checkbox,
  FormGroup,
} from "@mui/material";
import { useState } from "react";
import { useProposerCorrelationMatrix } from "../../lib/hooks";
import HeatMap from "./protoCharts/HeatMap";
import {
  getChartBottomIcons,
  getChartInfoIcons,
} from "./twitter/TwitterWordCloud";
import styles from "./../../styles/charts/chartStyle.module.css";
import { divergingscale } from "../../lib/util";
import { desc } from "../../lib/chartDescription";
interface ProposerCorrelationMatrixProps {
  colorRange?: any;
  shouldShowOption?: boolean;
}
const ProposerCorrelationMatrix = (props: ProposerCorrelationMatrixProps) => {
  //use colorRange as redgreenscale if you want a different color
  const { colorRange = divergingscale, shouldShowOption = true } = props;

  const [mergeProposers, setMergeProposers] = useState<string>("True");
  const [includeCorrelationColor, setIncludeCorrelationColor] =
    useState<string>("False");
  const [labels, setLabels] = useState<any>({
    x: true,
    y: true,
  });

  const onLabelChange = (event: any) => {
    const { name, checked } = event.target;
    console.log({ name, checked });
    setLabels((prevState: any) => {
      return {
        ...prevState,
        [name]: checked,
      };
    });
  };
  const { loading, proposerCorrelationData, error } =
    useProposerCorrelationMatrix({
      merge_new_previous_proposers: mergeProposers,
      include_correlation_colors: includeCorrelationColor,
    });

  let series: any = [];

  if (!loading) {
    const { Correlations, Parameters } = proposerCorrelationData;
    let length: number = Parameters.length;

    for (let i = 0; i < length; i++) {
      let DArray: any = [];
      for (let j = 0; j < length; j++) {
        DArray.push({
          x: Parameters[j],
          y: Correlations[i][j].toFixed(2),
        });
      }
      series.push({
        name: Parameters[i],
        data: DArray,
      });
    }
    series.reverse();
  }

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const errorHandler = () => {
    setIncludeCorrelationColor("False");
    setMergeProposers("True");
  };

  const content = (showMaxButton: boolean) => {
    return (
      <Paper elevation={3} className={styles.chartContainer}>
        <div className="horizontalCenter">
          <Typography className={styles.chartHeader}>
            Proposer Correlation Heatmap
          </Typography>
        </div>

        {(shouldShowOption || !showMaxButton) && (
          <>
            <div className={styles.flexibleControlRow}>
              <FormControl>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  className={styles.flexSelectFont}
                >
                  Previous and new proposer statistics
                </FormLabel>
                <RadioGroup
                  row
                  value={mergeProposers}
                  onChange={(event) => setMergeProposers(event.target.value)}
                  sx={{ justifyContent: "center" }}
                >
                  <FormControlLabel
                    value="True"
                    control={<Radio size="small" />}
                    label={
                      <Typography className={styles.flexSelectFont}>
                        Merge
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value="False"
                    control={<Radio size="small" />}
                    label={
                      <Typography className={styles.flexSelectFont}>
                        Show
                      </Typography>
                    }
                  />
                </RadioGroup>
              </FormControl>
            </div>

            <div className={styles.flexibleControlRow}>
              <FormControl>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  className={styles.flexSelectFont}
                >
                  Axis labels
                </FormLabel>
                <FormGroup row sx={{ justifyContent: "center" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={labels.x}
                        value={labels.x}
                        name="x"
                        size="small"
                        onChange={onLabelChange}
                      />
                    }
                    label={
                      <Typography className={styles.flexSelectFont}>
                        x-axis labels
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={labels.y}
                        value={labels.y}
                        name="y"
                        size="small"
                        onChange={onLabelChange}
                      />
                    }
                    label={
                      <Typography className={styles.flexSelectFont}>
                        y-axis labels
                      </Typography>
                    }
                  />
                </FormGroup>
              </FormControl>
            </div>
          </>
        )}

        {(!error || loading) && (
          <HeatMap series={series} colorRange={colorRange} labels={labels} />
        )}

        {!loading && error && (
          <div className="horizontalCenter">
            <Paper elevation={4} className={styles.chartErrorBox}>
              <Typography>
                No data for your selection, please try again.
              </Typography>
              <Button variant="contained" onClick={errorHandler}>
                Try again
              </Button>
            </Paper>
          </div>
        )}

        {getChartBottomIcons(showMaxButton, setOpen)}
        {getChartInfoIcons(desc["proposer"]["heatMap"])}
      </Paper>
    );
  };
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={styles.fullScreenChart}>{content(false)}</Box>
      </Modal>
      {content(true)}
    </>
  );
};

export default ProposerCorrelationMatrix;
